import { Button, Typography, styled } from '@mui/material'

export const Text = styled(Typography)(({ theme }) => ({
  '&.grey6': {
    color: theme.palette.grey[600]
  },
  '&.grey5': {
    color: theme.palette.grey[500]
  },
  '&.light': {
    color: theme.palette.primary.light
  },
  '&.blue': {
    color: theme.palette.info.main
  },
  '&.red': {
    color: theme.palette.error.dark
  },
  '&.orange': {
    color: theme.palette.warning.dark
  }
}))

export const DetailContainer = styled('div')(({ theme }) => ({
  padding: '24px 16px',
  border: '1px solid rgba(23, 26, 28, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: 8,
  gap: 24,
  maxWidth: 336,
  minWidth: 300,
  '&.info': {
    gap: 16,
    marginTop: 24
  },
  [theme.breakpoints.down('sm')]: {
    border: 'none',
    padding: '16px 0px',
    maxWidth: '100%'
  }
}))

export const StyledFavoriteButton = styled(Button)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  maxHeight: 40,
  height: 40,
  [theme.breakpoints.down('sm')]: {
    maxHeight: 44,
    height: 44,
    '& span p': {
      paddingLeft: 8,
      fontWeight: 500,
      fontSize: theme.typography.subtitle1.fontSize
    }
  },
  '& span p': {
    paddingLeft: 8,
    fontWeight: 500
  },
  '&.red': {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark
  },
  '&.redOut': {
    color: theme.palette.error.dark,
    borderColor: theme.palette.error.dark
  },
  '&.blue': {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.main
  },
  '&.orange': {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark
  },
  '&.green': {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark
  }
}))
